import { Pipe, PipeTransform } from '@angular/core';

/**
 * Finds an object from given source using the given key - value pairs
 */
@Pipe({
  name: 'findByKey',
})
export class FindByKeyPipe implements PipeTransform {
  /**
   * Constructor
   */
  constructor() {}

  /**
   * Transform
   *
   * @param value A string or an array of strings to find from source
   * @param key Key of the object property to look for
   * @param source Array of objects to find from
   */
  transform(
    value: string | string[],
    key: string,
    source: any[],
    property?: string
  ): any {
    // If the given value is an array of strings...
    if (Array.isArray(value)) {
      return value.map((item) => this.getElement(source, key, item, property));
    }

    // If the value is a string...
    return this.getElement(source, key, value, property);
  }

  private getElement(
    source: any[],
    key: string,
    item: string,
    property: string
  ) {
    const element = source.find((sourceItem) => sourceItem[key] === item);

    return property ? element?.[property] : element;
  }
}
